import { pdfjs } from "react-pdf";

// Copied from pdfjs-dist by scripts/copy-pdf-worker.js. The version query
// keeps a cached worker from outliving a pdfjs-dist upgrade.
export const pdfWorkerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js?v=${pdfjs.version}`;
